import tw, { styled, css } from 'twin.macro';
import { Link } from 'gatsby';
import Icon from '@/components/Icon/IconSprite';

export const StyledListItemNav = styled.li<{ navDirection: 'prev' | 'next' }>`
  ${tw`absolute`}
  ${tw`top-0`}
  ${tw`lg:relative`}

  ${({ navDirection }) =>
    navDirection === 'prev' &&
    css`
      ${tw`left-0`}
      ${tw`lg:pr-6`}
    `}

  ${({ navDirection }) =>
    navDirection === 'next' &&
    css`
      ${tw`right-0`}
      ${tw`lg:pl-6`}
    `}
`;

export const linkStyle = css`
  ${tw`flex`}
  ${tw`items-center`}
  ${tw`justify-center`}
  ${tw`h-[40px]`}
  ${tw`min-w-[40px]`}
  ${tw`relative`}
  ${tw`font-bold font-inter`}
  ${tw`text-tag-m text-primary-p1`}
`;

export const StyledNavLink = styled(Link)`
  ${linkStyle}
`;

export const StyledNavLinkButton = styled.button`
  ${linkStyle}
  ${tw`cursor-not-allowed`}
  ${tw`opacity-30`}
`;

export const StyledNavLinkTitle = styled.span`
  ${tw`flex`}
  ${tw`uppercase`}
  ${tw`font-inter`}
  ${tw`text-primary-p1 text-tag-m`}
`;

export const StyledNavLinkIcon = styled(Icon)<{
  direction: 'prev' | 'next';
}>`
  ${tw`w-[17px]`}

  ${({ direction }) =>
    direction === 'next'
      ? css`
          ${tw`ml-2`}
          ${tw`rotate-180`}
          ${tw`order-1`}
        `
      : tw`mr-2`}
`;
